import {ErrorLocationType, HttpType} from "@/utilities/system/enums/Enums";
import {useSystemStore} from "@/stores/system/SystemStore";
import jwt_decode from "jwt-decode";
import sleep from "@/utilities/system/helpers/Sleeper";
import ErrorResponseHandler from "@/utilities/system/helpers/ErrorHandler";
import {PathHelper} from "@/utilities/system/helpers/PathHelper";
import {GeneralResponse} from "@/models/system/api/Responses";
import OAuthService from "@/utilities/system/services/OAuthService";
import {User} from "oidc-client";
import {i18n} from "@/utilities/system/i18n/config";

//TODO needs to be refactored since tokens are 'self managed with oAuthService'
export class TokenService {
    private uriHelper: PathHelper;
    private isRefreshingToken:boolean = false;

    constructor(){
        this.uriHelper = new PathHelper();
    }

    public async GetAccessToken():Promise<string|undefined>{
        try {
            const oAuthService = OAuthService.getDefaultInstance();
            const oAuthUser = await oAuthService.userManager.getUser();
            return oAuthUser!.access_token ?? undefined;
        }
        catch(error) {
            console.log("Error getting access token:", error);
            return undefined;
        }
    }

    //TODO needs to be refactored since tokens are 'self managed with oAuthService'
    public async EnsureFreshToken(path:string, type:HttpType):Promise<string>{
        // filter out login for token refresh
        if (this.doesntRequireToken(path)) return "";

        const systemStore = useSystemStore();
        // hide errors but exclude deletion
        if(systemStore.error.location !== ErrorLocationType.none && type !== HttpType.delete) systemStore.error.location = ErrorLocationType.none;

        const token = await this.GetAccessToken();
        if(!token) {
            console.log("fatal error when ensuring fresh token: token not found");
            //TODO push login route?!
            return ""
        }
        const convertedToken = jwt_decode(token!) as { exp:number }; // read token from store as object with exp-property of type number
        const expiration = (convertedToken.exp - 25) * 1000; // calling refresh 25 seconds early
        const now = Date.now();

        if(now > expiration) {
            await this.RefreshAccessToken();
        }

        return "done";
    }

    /*
        checks if a refresh is already in progress and if so holds the api call till refresh is done
        if no refresh is in progress this function refreshes the tokens
    */
    public async RefreshAccessToken():Promise<string>{
        let waitedForRefresh = false;

        // if refresh is in progress hold calls
        while(this.isRefreshingToken){
            console.log("waiting");
            await sleep(66);
            waitedForRefresh = true;
        }

        // drop call when it was hold by previous refresh of the token
        if (waitedForRefresh) return "done";

        this.isRefreshingToken = true;

        const oAuthUser = await this.TryGetRefreshedOAuthUser();
        if(!oAuthUser){
            const {t} = i18n.global;

            ErrorResponseHandler.handleError(new GeneralResponse(401, t("general.tokens.expired")), ErrorLocationType.login);

            this.isRefreshingToken = false;

            return "error";
        }

        this.isRefreshingToken = false;

        return "done";
    }

    private doesntRequireToken(path:string):boolean{
        const whitelist = [
            this.uriHelper.misc.getStartupConfigPath(),
        ]

        return whitelist.includes(path);
    }

    private async TryGetRefreshedOAuthUser():Promise<User|null>{
        try {
            const oAuthService = OAuthService.getDefaultInstance();
            const resp = await oAuthService.refreshTokens();
            return resp as User
        }
        catch (e) {
            console.log("refreshing failed", e)
            return null;
        }
    }
}
